<template>
  <div class="crud_module--cp_config_edit">
    <div class="inner-wrap">
      <el-form ref="form" class="form" :model="cpConfig">
        <div class="row" v-for="(row,index) in config_basic" :key="index">
          <div class="field" v-for="(field,index) in row" :key="index">
            <el-form-item class="input-field"  v-model="cpConfig[field.key]">
              <!-- <el-checkbox v-model="input[field.key]" v-if="field.type == 'boolean'" :label="$t(`field.${key}.${field.key}`)" true-label="1" false-label="0"/> -->
              <div class="checkbox-group" v-if="field.type == 'boolean'">
                <input type="checkbox" v-model="cpConfig[field.key]" true-value="1" false-value="0" :id="`${field.key}--${index}`" :disabled="cpConfig[field.key] == 1">
                <label class="label" :for="`${field.key}--${index}`">{{  field.key }}</label>
              </div>
              <div class="label-group" v-else>
                <label class="label" :for="field.key">{{ tran(key, field.key) }}</label>
                <textarea rows="10" v-if="field.row && field.row > 1" v-model="input[field.key]" ></textarea>
                <input v-model="cpConfig[field.key]" :type="field.password ? 'password' : 'text'" :disabled="field.disable == 1" v-else>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="row" v-for="(row,index) in cp_config_json" :key="'a' + index" >
          <div class="field" v-for="(field,index) in row" :key="'b' + index">
            <el-form-item class="input-field"  v-model="configJson[field].Type">
              <div class="control-group" v-if="configJson[field].Type == 'Selection'">
                <div class="label">{{ tran(key, field) }}</div>{{key}}
                <select v-model="configJson[field].Value">
                  <option :selected="configJson[field].Value === item" v-for="(item, index) in configJson[field].Option" :key="'c' + index">{{ item }}</option>-->
                </select>
              </div>
              <div class="label-group" v-if="configJson[field].Type == 'Range' || configJson[field].Type == 'Text'" >
                <label class="label" :for="field">{{field}}</label>
                <textarea rows="10" v-if="field.row && field.row > 1" v-model="configJson[field].Value"></textarea>
                <input v-model="configJson[field].Value" :type="field.password ? 'password' : 'text'" v-else>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="checkbox-group">
          <input type="checkbox" v-model="cpConfig.pending"  />
          <label class="label" >pending</label>
        </div>
      </el-form>
      <div class="action-btn">
        <el-button  @click="closePopup">{{ $t("button.back") }}</el-button>
        <el-button v-if="isCreate==true" type="primary" @click="create">{{ $t("button.create") }}</el-button>
        <el-button v-if="isCreate==false" type="primary" @click="update">{{ $t("button.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {selectedConfig: Object,
            currentSetting: Array,
            close: {type: Function},
            isCreate: Boolean},
  methods: {
    async create() {
      let configJsonString = JSON.stringify(this.configJson);
      this.cpConfig.config_json = configJsonString;
      this.cpConfig.cp_config_id = null;
      console.log("create cpConfig", this.cpConfig);
      await this.updateCpConfig(this.cpConfig);
    },
    async update() {
      let configJsonString = JSON.stringify(this.configJson);
      this.cpConfig.config_json = configJsonString;
      console.log("update: ", this.cpConfig);
      await this.updateCpConfig(this.cpConfig);
    },
    closePopup() {
      this.close();
    },
    async updateCpConfig(config) {
      await this.$axios.put(`/cps/${this.cpConfig.cp_id}/cpConfig`, {
        ...this.cpConfig
      }).then(res=>{
        this.closePopup();
        return true;
      }).catch(err=>{ return false; });
    },
  },
  created() {
    console.log("selectedConfig", this.selectedConfig);
    console.log("currentSetting", this.currentSetting);
    Object.assign(this.cpConfig, this.selectedConfig);
    this.config_basic = this.cp_config_edit.map(row=>{
      return row.map(field=>{
        let current = this.currentSetting.find(f=>f.key==field);
        if(current) {
          return current;
        }else {
          return {key: field};
        }
      })
    });
    console.log("config_basic", this.config_basic);
    this.configJson = JSON.parse(this.cpConfig.config_json);
    if(this.configJson["Time Select Interval Min"] == undefined) {
      this.configJson["Time Select Interval Min"] =
          {"Type":"Range","Authority":"Admin","Value":15,"Option":[1,30,5]};
    }
    if(this.configJson["Custom Fields"] == undefined) {
      this.configJson["Custom Fields"] =
          {"Type":"Selection","Authority":"Admin","Value":"Yes","Option":["Yes","No"]};
    }
    console.log("config_json", this.configJson);
    window.addEventListener('resize', reportWindowSize);
    function reportWindowSize() {
      document.getElementById("popup").style.maxHeight = window.innerHeight + "px";
    }
  },
  data() {
    return {
      cp_config_edit: [
        ["cp_id"],
        ["ip_address", "mac_address"],
        ["description", "fw_ver" ],
      ],
      cp_config_json: [
        ["Time Zone", "Time Slot Maximum (Min)", "Phase", "Admin Card"],
        ["Server Path", "Time Select Stop Button"],
        ["Clock", "Network Timeout (ms)", "Time Select Interval Min"],
        ["Remote OCPP Server Path", "Powermeter Type"],
        ["Powermeter ID", "Auto Unlock Interval (ms)", "LPRS Engine", "Maximum Capacity (A)"],
        ["UART Port", "Time Select Fully Charge"],
        ["Remote OCPP Server Username", "Charging detail"],
        ["Window", "LPRS Engine Port", "LPRS", "Station Name"],
        ["Serial No", "Type", "Authentication", "Remote OCPP Server Password"],
        ["Default Capacity (A)", "Backdoor Server"],
        ["End upon state A", "Hardware Version", "Custom Fields"]
      ],
      config_basic : [],
      configJson : {},
      cpConfig: {},
      key: ""
    }
  }
}
</script>

<style lang="scss">
.crud_module--cp_config_edit{
  width: 70vw;
  .inner-wrap{
    // height: 90%;
    // width: 95%;
    // max-width: 800px;
    // max-height: 60%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: #FFFFFF;
    .form{
      flex-grow: 1;
      overflow-y:scroll;
      height: 70vh;
      .row{
        display: flex;
        width: 100%;
        max-width: 100%;
        .field{
          flex-grow: 1;
          // width: 100%;
          max-width: 100%;
          :first-child{
            margin-right: 5px;
          }
          &:not(:first-child) {
            margin-left: 5px;
          }
        }
      }
      .checkbox-group{
        display: flex;
        align-items: center;
      }
      .label-group,
      .control-group{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .label{
          // width: 150px;
          // min-width: 150px;
        }
        input:not([type="checkbox"]){
          height: 30px;
          // width: 100%;
        }
        textarea{
          width: 100%;
        }
      }
      .el-form-item{
        margin-bottom: 10px;
        .el-select{
          width: 100%;
        }
        select{
          height: 40px;
          line-height: 40px;
          width: 100%;
        }
      }
      .field{
        &:not(:last-child){
          // margin-bottom: 10px;
        }
      }
    }
    .action-btn{
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }

}
}
</style>